import _ from 'lodash';

import { FadeInAnimation } from '../../shared';

import PropTypes from 'prop-types';

const RoomTypeFloorPlan = (props) => {
    const { selectedRoomType } = props;
    const floorplanSrc = _.get(selectedRoomType, 'floorplanImages[0]');

    if (!floorplanSrc) {
        return null;
    }

    return (
        <div id="floor-plan-section">
            <FadeInAnimation>
                <h3 style={{ marginTop: 100 }}>Floor Plan</h3>
                <p className='room-type-floor-plan-details'>
                    Please note this floor plan is for reference purposes only an may not be an
                    exact representation of this apartment.
                </p>
            </FadeInAnimation>
            <img className='room-type-floor-plan-img' src={floorplanSrc} alt="floorplan" width="100%" />
        </div>
    );
};

export default RoomTypeFloorPlan;

RoomTypeFloorPlan.propTypes = {
    selectedRoomType: PropTypes.object,
};

